<template>
  <b-row no-gutters>
    <b-modal
      id="modal-lock-notify"
      ref="modalLockKey"
      :hide-header="true"
      :hide-footer="true"
      :cancel-disabled="true"
      content-class="blah"
      dialog-class="lockWrapper"
      body-class="lockBody"
    >
      <b-row
        no-gutters
        class="lock-title"
      >
        <lock-outline-icon
          :size="24"
          fill-color="#4A4A4A"
          class="icon"/>
        <span class="lock-title-text">
          {{ $t('MEETING.LOCK_MEETING') }}
        </span>
      </b-row>
      <b-row
        no-gutters
        class="lock-desc">
        <span class="lock-desc-text">
          {{ $t('MEETING.LOCK_CONFIRM') }}
        </span>
      </b-row>
      <b-row
        no-gutters
        class="lock-btns"
      >
        <b-btn
          size="sm"
          variant="secondary-light"
          @click="cancelModKey">
          {{ $t('MEETING.CANCEL') }}
        </b-btn>
        <b-btn
          size="sm"
          variant="primary-light"
          style="margin-left:16px"
          @click="submitModKey">
          {{ $t('MEETING.LOCK_MEETING') }}
        </b-btn>
      </b-row>
    </b-modal>
  </b-row>
</template>

<script>
import LockOutlineIcon from "icons/LockOutline"
export default {
  name: 'LockNotify',
  components: {
    'lock-outline-icon': LockOutlineIcon
  },
  setup(props, context) {
    function cancelModKey() {
      context.refs.modalLockKey.hide()
    }

    function submitModKey() {
      context.parent.lockMeeting(true)
      context.refs.modalLockKey.hide()
    }
    
    return {
      submitModKey,
      cancelModKey
    }
  }
}
</script>
<style>
.lockWrapper {
  max-width: 420px;
  padding: 0;
}
.lockBody {
  min-height: 116px;
  background-color: #ffffff;
  padding: 16px;
  border-radius: .25rem !important;
}
.lock-title {
  width: 348px;
  margin: 16px;
}
.lock-title-text {
  color: #242F3D;
  font-weight: 600;
  line-height: 24px;
  font-size: 16px;
  margin-left: 8px;
}
.lock-desc {
  margin-left: 48px;
}
.lock-desc-text {
  color: #282828;
  font-size: 14px;
  inline-size: 332px;
  overflow-wrap: break-word;
}
.lock-btns {
  margin-top: 34px;
  display: flex;
  justify-content: flex-end;
}
</style>


// WEBPACK FOOTER //
// src/components/LockNotify.vue